require('./bootstrap.js');
import Vue from 'vue';
import VueMeta from 'vue-meta';
import PortalVue from 'portal-vue';
import { app, plugin } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import Buefy from 'buefy';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Bootstrap Axios into $axios
Vue.prototype.$axios = window.axios;

// font awesome
library.add(fas);
Vue.component('vue-fontawesome', FontAwesomeIcon);

// custom global components
Vue.component(
  'SideMenu',
  require('./Components/Management/Sidemenu.vue').default
);
Vue.component(
  'ManagementHeader',
  require('./Components/Management/Header.vue').default
);

Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(plugin);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
  customIconPacks: {
    fas: {
      sizes: {
        default: 'lg',
        'is-small': '1x',
        'is-medium': '2x',
        'is-large': '3x',
      },
      iconPrefix: '',
    },
  },
});

// Ziggy (routing)
Vue.prototype.$route = (...args) => route(...args).url();

// initialise intertia
InertiaProgress.init();

const el = document.getElementById('app');
const appName = process.env.MIX_APP_NAME ?? 'Navigator 360';

new Vue({
  metaInfo: {
    titleTemplate: (title) => (title ? `${title} - ${appName}` : appName),
  },
  render: (h) =>
    h(app, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: (name) => require(`./Pages/${name}`).default,
      },
    }),
}).$mount(el);

// create mixin to display form validation errors
Vue.mixin({
  methods: {
    validationError(field) {
      if (this.$page.props.errors) {
        if (this.$page.props.errors?.hasOwnProperty(field)) {
          return this.$page.props.errors[field];
        }
      }
      return null;
    },
  },
});
